<template>
  <div>
    <p>
      Aquesta tarja serveix per a <strong>publicitar actes de signatura de firmes</strong>,
      per a la campanya <strong>Exigim igualtat, exigim respecte</strong>.
    </p>
    <p>Simplement empleneu amb la informació corresponent del vostre acte tal i com es mostra a l'exemple</p>
    <div class="help-examples">
      <img src="./examples/11.png" alt="Exemple 1:1" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'event-help'
}
</script>
